module.exports = __webpack_public_path__ + "img/step1-b.4017ac36.png";